import React from "react";
import { loadModules } from "esri-loader";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import { Redirect } from "react-router";
import { Link } from 'react-router-dom';

import {
    arcgisJSUrl,
    arcgisCSSUrl,
    arcgisGeocodeUrl,
    iwkPrintServiceUrl,
    pipe_material,
    diameter_mm
} from "../../utilities/constants";
import manhole from "../../images/manhole.png";
import gravityMains from "../../images/gravityMains.png";
import pressurizedMains from "../../images/pressurizedMains.png";
import publicSTP from "../../images/publicSTP.png";
import npsServiceArea from "../../images/npsServiceArea.png";
import iwk from "../../images/logo.jpg";

class UserDefinedRegion extends React.Component {
    constructor(props) {
        super(props);
        const apiUrl = arcgisJSUrl;

        this.state = {
            loading: true,
            tokenDetail: JSON.parse(localStorage.getItem("tokenDetail")),
            isChangeToken: false,
            apiUrl: apiUrl,
            apiCssUrl: apiUrl + arcgisCSSUrl,
            sketchGeometries: JSON.parse(localStorage.getItem("sketchGeometries")) || [],
            orderIdRandom: this.props.match.params.id,
            //features: null,
            minScale: 7000,
            latitude: 4,
            longitude: 102,
            features: [],
            view: null,
            activeList: null
        };

        //this.checkToken();
    }

    async componentDidMount() {
        while (!this.state.isChangeToken) {
            try {
                await this.getToken();
                this.setState({
                    isChangeToken: true
                });
            } finally {
            }
        }
        setInterval(() => {
            this.getToken();
        }, 5000);
        await this.getMinScale();
        this.initializeMap();
    }

    decamelize = (str, separator) => {
        separator = typeof separator === "undefined" ? " " : separator;

        return str
            .replace(/([a-z\d])([A-Z])/g, "$1" + separator + "$2")
            .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, "$1" + separator + "$2")
            .toLowerCase()
            .split(" ")
            .map(function (word) {
                return word.replace(word[0], word[0].toUpperCase());
            })
            .join(" ");
    };

    getMinScale = async () => {
        fetch("api/GetData/GetConfigValues?configName=MinScale")
            .then(response => response.json())
            .then(data => {
                this.setState({ minScale: data[0].value });
            });
    };

    getPopupTemplate = (attributes, title) => {
        var popupTemplate = `<div class="table-responsive"><table class="table table-sm table-hover">
                                              <tbody>`;
        var attributeKeys = Object.keys(attributes);
        for (var i = 0; i < attributeKeys.length; i++) {
            var label = attributeKeys[i].replace("IGISPROD.SDE.PUBLIC_STP.", "").replace("IGISPROD.SDE.AMIS.", "").replace("IGISPROD.sde.AMIS.", "");
            var value = attributes[attributeKeys[i]] || "-";

            if ((title === 'Gravity Mains Features' || title === 'Pressurized Mains Features') && label === 'PIPE_MATERIAL' && value !== "-") {
                console.log(label + ": " + value);
                value = pipe_material[value];
                console.log(label + ": " + value);
            }

            if ((title === 'Gravity Mains Features' || title === 'Pressurized Mains Features') && label === 'DIAMETER_MM' && value !== "-") {
                console.log(label + ": " + value);
                value = diameter_mm[value];
                console.log(label + ": " + value);
            }

            popupTemplate += `<tr>
                                <td>${label}</td>
                                <td>${value}</td>
                              </tr>`;
        }
        popupTemplate += `</tbody>
                                        </table><div>`;
        return popupTemplate;
    };

    getGraphicAttributes = (geometry, title) => {
        var geometryData;
        var symbolData;
        var iwkAttr = this.getIWKAttributes(title);
        if (geometry.paths) {
            geometryData = {
                type: "polyline",
                paths: geometry.paths
            };
            symbolData = {
                type: "simple-line",
                color: iwkAttr.color,
                width: 4
            };
        } else if (geometry.rings) {
            geometryData = {
                type: "polygon",
                rings: geometry.rings
            };
            symbolData = {
                type: "simple-fill",
                color: [0, 0, 0, 0],
                outline: {
                    style: iwkAttr.style,
                    color: iwkAttr.color,
                    width: 2
                }
            };
        } else {
            geometry.type = "point";
            geometryData = geometry;
            symbolData = {
                type: "picture-marker",
                url: iwkAttr.url,
                color: iwkAttr.color,
                outline: {
                    color: [255, 255, 255],
                    width: 1
                }
            };
        }
        return {
            geometry: geometryData,
            symbol: symbolData
        };
    };

    getIWKAttributes(title) {
        if (title === "manholeFeatures") {
            return {
                url: manhole,
                color: [226, 119, 40]
            };
        } else if (title === "gravityMainsFeatures") {
            return {
                color: [38, 115, 0]
            };
        } else if (title === "pressurizedMainsFeatures") {
            return {
                color: [0, 115, 76]
            };
        } else if (title === "npsServiceAreaFeatures") {
            return {
                color: [115, 76, 0],
                style: "dash-dot"
            };
        } else if (title === "publicSTPFeatures") {
            return {
                color: [115, 0, 76, 255],
                style: "solid"
            };
        } else {
            return {
                color: [244, 64, 82],
                url: iwk,
                style: "solid"
            };
        }
    }

    getToken = () => {
        return new Promise(async (resolve, reject) => {
            if (
                !this.state.tokenDetail ||
                new Date() > new Date(this.state.tokenDetail.tokenExpired)
            ) {
                try {
                    await this.fetchToken();
                } catch (err) {
                    reject(err);
                }
            }
            resolve(true);
        });
    };

    fetchToken = async () => {
        var response = await fetch("api/GetData/GetTokenArcgis");
        var data = await response.json();
        var dd = new Date();
        dd.setHours(dd.getHours() + 1);
        var tokenDetail = { token: data.token, tokenExpired: dd };
        this.setState({ tokenDetail });
        localStorage.setItem("tokenDetail", JSON.stringify(tokenDetail));
    };

    zoomToBookmark = geometry => {
        loadModules(["esri/geometry/support/webMercatorUtils"]).then(
            ([webMercatorUtils]) => {
                var target = webMercatorUtils.webMercatorToGeographic(geometry.target);
                geometry.target = [target.rings];
                //console.log(geometry);
                this.state.view.goTo(geometry, {
                    duration: 3500
                });
            }
        );
    };

    initializeMap = () => {
        loadModules(
            [
                "esri/views/MapView",
                "esri/Map",
                "esri/layers/GraphicsLayer",
                "esri/Graphic",
                "esri/widgets/Search",
                "esri/widgets/BasemapGallery",
                "esri/widgets/Expand",
                "esri/identity/IdentityManager",
                "esri/widgets/ScaleBar",
                "esri/widgets/Print",
                "esri/widgets/LayerList",
                "esri/tasks/Locator"
            ],
            { url: this.state.apiUrl, css: this.state.apiCssUrl }
        ).then(
            async ([
                MapView,
                Map,
                GraphicsLayer,
                Graphic,
                Search,
                BasemapGallery,
                Expand,
                IdentityManager,
                ScaleBar,
                Print,
                LayerList,
                Locator
            ]) => {
                const bufferLayer = new GraphicsLayer();
                bufferLayer.title = "Buffer Layer";

                //await this.letsWait();

                IdentityManager.registerToken({
                    server: "https://igis.iwk.com.my/geoserver/rest/services",
                    token: this.state.tokenDetail.token
                });

                /*this.state.isChangeToken = false;
                    let checkTokenExpired = () => {
                        if (this.state.isChangeToken) {
                            IdentityManager.registerToken({
                                server: "https://igis.iwk.com.my/geoserver/rest/services",
                                token: this.state.tokenDetail.token
                            });
                            this.state.isChangeToken = false;
                        }
                    };
        
                    setInterval(() => { checkTokenExpired() }, 5000);*/

                const map = new Map({
                    basemap: "hybrid",
                    layers: [bufferLayer]
                });

                const view = new MapView({
                    container: "viewDiv",
                    map: map,
                    zoom: 7,
                    center: [102, 4]
                });

                this.setState({
                    view
                });

                var bufferSymbol = {
                    type: "simple-fill",
                    color: [0, 0, 0, 0],
                    style: "solid",
                    outline: {
                        color: [50, 50, 50, 255],
                        width: 2
                    }
                };

                var response = await fetch(
                    "api/Order/GetOrder?orderIdRandom=" + this.state.orderIdRandom
                );

                var data = await response.json();
                var features = await data.dataReturn;

                console.log(features);

                if (features === "UnavailableProduct") {
                    return this.props.history.push("/UnavailableProduct");
                }

                if (features === "ExpiredSubscription") {
                    return this.props.history.push("/ExpiredSubscription");
                }

                this.setState({
                    loading: false,
                    features
                });

                var featureKeys = Object.keys(features[0]);

                //console.log(featureKeys);

                featureKeys.map(key => {
                    if (key !== "graphics") {
                        var resultsLayer = new GraphicsLayer();
                        resultsLayer.title = this.decamelize(key);
                        console.log(resultsLayer.title);
                        features.map(feature => {
                            if (feature[key]) {
                                feature[key].map(graphic => {
                                    if (graphic.attributes) {
                                        var popupTemplate = {
                                            title: this.decamelize(key),
                                            content: this.getPopupTemplate(graphic.attributes, resultsLayer.title)
                                        };
                                    }
                                    if (graphic.geometry) {
                                        var graphicAttr = this.getGraphicAttributes(
                                            graphic.geometry,
                                            key
                                        );
                                    }
                                    var symbolGraphic = new Graphic({
                                        geometry: graphicAttr.geometry,
                                        symbol: graphicAttr.symbol,
                                        popupTemplate
                                    });

                                    if (resultsLayer.title === 'Public Stp Features') {
                                        var labelGraphic = new Graphic({
                                            geometry: graphicAttr.geometry,
                                            symbol: {
                                                type: "text",
                                                text: graphic.attributes["IGISPROD.SDE.PUBLIC_STP.ASSET_NO"],
                                                font: {
                                                    size: 10,
                                                    family: "Arial"
                                                },
                                                horizontalAlignment: "left",
                                                color: [115, 0, 76],
                                                haloSize: 1,
                                                haloColor: "white"
                                            }
                                        });

                                        resultsLayer.add(labelGraphic);
                                    }

                                    resultsLayer.add(symbolGraphic);
                                    //resultsLayer.minScale = this.state.minScale;
                                    return graphic;
                                });
                            }
                        });
                        map.add(resultsLayer);
                    } else {
                        features.map(feature => {
                            var graphicsAPI = JSON.parse(feature[key]);
                            /* if (
                                  Object.prototype.toString.call(graphicsAPI) == "[object Array]"
                                ) {
                                  graphicsAPI.map(graphicAPI => {
                                    //if (!graphicAPI.symbol) {
                                    graphicAPI.symbol = bufferSymbol;
                                    //}
                                    bufferLayer.add(JSON.parse(graphicAPI));
                                  });
                                } else { */
                            graphicsAPI.symbol = bufferSymbol;
                            bufferLayer.add(graphicsAPI);
                            //   }
                        });
                    }
                });

                document.getElementById("bookmarks").className = "d-block";/*.removeClass('d-none')*/;

                view.on("pointer-move", function (evt) {
                    showCoordinates(view.toMap({ x: evt.x, y: evt.y }));
                });

                var showCoordinates = pt => {
                    /*var coords = "Lat/Lon " + pt.latitude.toFixed(3) + " " + pt.longitude.toFixed(3) +
                              " | Scale 1:" + Math.round(view.scale * 1) / 1 +
                              " | Zoom " + view.zoom;*/
                    this.setState({
                        latitude: pt.latitude.toFixed(3),
                        longitude: pt.longitude.toFixed(3)
                    });
                    /*if ((Math.round(view.scale * 1) / 1) === 10000) {
                              //resultsLayer.hide();
                          }*/
                };

                const searchWidget = new Search({
                    view: view,
                    container: "search",
                    includeDefaultSources: false,
                    sources: [
                        {
                            locator: new Locator({ url: arcgisGeocodeUrl }),
                            singleLineFieldName: "SingleLine",
                            name: "Geocoding Service",
                            placeholder: "Find Address and Place",
                            maxResults: 3,
                            maxSuggestions: 6,
                            suggestionsEnabled: true,
                            minSuggestCharacters: 0
                        }
                    ]
                });

                searchWidget.on("search-focus", () => {
                    const inputs = document.querySelectorAll(".esri-search__input");
                    for (var i = 0; i < inputs.length; i++) {
                        inputs[i].onfocusout = null;
                    }
                });

                view.ui.add(searchWidget, {
                    position: "top-left"
                });

                var basemapGallery = new BasemapGallery({
                    view: view
                });

                var scaleBar = new ScaleBar({
                    view: view,
                    unit: "dual"
                });

                var print = new Print({
                    view: view,
                    printServiceUrl: iwkPrintServiceUrl
                });

                var layerList = new LayerList({
                    view: view
                });

                var bgExpand = new Expand({
                    view: view,
                    expandIconClass: "esri-icon-basemap",
                    expandTooltip: "Basemap",
                    content: basemapGallery
                });

                var printExpand = new Expand({
                    view: view,
                    expandIconClass: "esri-icon-printer",
                    expandTooltip: "Print",
                    content: print
                });

                var layerExpand = new Expand({
                    view: view,
                    expandIconClass: "esri-icon-layer-list",
                    expandTooltip: "Layer List",
                    content: layerList
                });
                
                var legendExpand = new Expand({
                    view,
                    expandIconClass: "esri-icon-maps",
                    expandTooltip: "Legend",
                    content: `<div className="table-responsive" style="opacity: 1 !important;"><table class="table table-hover table-sm tableLegend">
                    <tbody>
                        <tr className="table-info">
                            <td>Manhole</td>
                            <td><img src="${manhole}"/></td>
                        </tr>
                        <tr className="table-info">
                            <td>Gravity Mains</td>
                            <td><img src="${gravityMains}"/></td>
                        </tr>
                        <tr className="table-info">
                            <td>Pressurized Mains</td>
                            <td><img src="${pressurizedMains}"/></td>
                        </tr>
                        <tr className="table-info">
                            <td>Public STP</td>
                            <td><img src="${publicSTP}"/></td>
                        </tr>
                    </tbody>
                </table> <div>`
                });

                var bookmarkExpand = new Expand({
                    view: view,
                    expandIconClass: "esri-icon-bookmark",
                    expandTooltip: "Bookmark",
                    content: document.getElementById("bookmarks")
                });

                view.ui.add(bgExpand, "top-right");
                view.ui.add(scaleBar, {
                    position: "bottom-left"
                });
                view.ui.add(printExpand, {
                    position: "top-right",
                    index: 1
                });
                view.ui.add(bookmarkExpand, "bottom-right");
                view.ui.add([legendExpand, layerExpand], "top-right");
            }
        );
    };

    render() {
        return (
            <div className="border p-2" style={{ position: "relative" }}>
                <div id="viewDiv" className="mapViews"></div>
                <div id="search"></div>
                <div id="coordinates">
                    Coordinates: {this.state.latitude} , {this.state.longitude}
                </div>
                {this.state.loading && (
                    <div id="udrLoading">
                        <LoadingSpinner />
                    </div>
                )}
                <div id="bookmarks" className="d-none">
                    <h5>
                        <span aria-hidden="true" className="esri-icon-bookmark"></span>{" "}
                        Bookmark
                    </h5>
                    {this.state.features.length > 0 && (
                        <ul className="list-group list-group-flush">
                            {this.state.features.map(feature => {
                                let { graphics } = feature;
                                graphics = JSON.parse(graphics);
                                return (
                                    <li
                                        className={
                                            this.state.activeList ===
                                                graphics.attributes["BufferId"]
                                                ? "list-group-item list-group-item-danger"
                                                : "list-group-item"
                                        }
                                        onClick={() => {
                                            this.zoomToBookmark({
                                                target: graphics.geometry,
                                                zoom: 16
                                            });
                                            this.setState({
                                                activeList: graphics.attributes["BufferId"]
                                            });
                                        }}
                                        key={graphics.attributes["BufferId"]}
                                    >
                                        {graphics.attributes["BufferId"]}
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                    {this.state.features.length === 0 && !this.state.loading && (
                        <p>No data found</p>
                    )}
                    {this.state.features.length === 0 && this.state.loading && (
                        <LoadingSpinner />
                    )}
                </div>

                <div className="col-sm-12 text-center">
                    <Link className="" to="/">Go to Home </Link>
                </div> 
            </div>
        );
    }
}

export default UserDefinedRegion;



// WEBPACK FOOTER //
// ./src/components/PurchaseProduct/UserDefinedRegion.js